module.exports = __webpack_public_path__ + "static/media/mu.65529fc7.png";